import { render, staticRenderFns } from "./ItemTemplate.vue?vue&type=template&id=80403f0e&"
import script from "./ItemTemplate.vue?vue&type=script&lang=js&"
export * from "./ItemTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports